/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/undo_medium'
export default icon
